var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoto(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0351 11.4277C12.6205 11.4277 10.6572 13.3611 10.6572 15.7388C10.6572 18.1166 12.6205 20.0499 15.0351 20.0499C17.4497 20.0499 19.4129 18.1166 19.4129 15.7388C19.4129 13.3611 17.4497 11.4277 15.0351 11.4277Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1108 9.36479H20.1842V8.2177C20.1842 7.26432 19.3973 6.59961 18.4292 6.59961H11.6406C10.6725 6.59961 9.8162 7.26432 9.8162 8.2177V9.36479H8.3042V8.30126H6.5762V9.36479H5.95905C4.99091 9.36479 4.2002 10.0219 4.2002 10.9715V21.6524C4.2002 22.6058 4.99091 23.3996 5.95905 23.3996H24.1108C25.0789 23.3996 25.8002 22.602 25.8002 21.6524V10.9715C25.8002 10.0219 25.0789 9.36479 24.1108 9.36479ZM15.0349 21.3447C11.8952 21.3447 9.34177 18.8302 9.34177 15.7384C9.34177 12.6465 11.8952 10.1321 15.0349 10.1321C18.1746 10.1321 20.7281 12.6465 20.7281 15.7384C20.7281 18.8302 18.1746 21.3447 15.0349 21.3447Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoto);
export default __webpack_public_path__ + "static/media/Photo.d369c8ae.svg";
export { ForwardRef as ReactComponent };